import { Clock, Check, X, ChevronRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import type { GetChangeRequestsResponse } from "@shared/types/payloads/GetChangeRequestsResponse";

interface RequestListItemProps {
  request: GetChangeRequestsResponse;
  onClick: () => void;
}

export function RequestListItem({ request, onClick }: RequestListItemProps) {
  const statusConfig = {
    pending: {
      icon: Clock,
      color: "text-amber-400",
      bg: "bg-amber-500/10",
      border: "border-amber-500/20",
    },
    approved: {
      icon: Check,
      color: "text-emerald-400",
      bg: "bg-emerald-500/10",
      border: "border-emerald-500/20",
    },
    rejected: {
      icon: X,
      color: "text-red-400",
      bg: "bg-red-500/10",
      border: "border-red-500/20",
    },
  };

  const config = statusConfig[request.status];
  const StatusIcon = config.icon;

  return (
    <button onClick={onClick} className="w-full text-left group">
      <div
        className={`flex items-center gap-4 p-4 rounded-xl border ${config.border} ${config.bg} hover:bg-white/5 transition-all duration-200`}
      >
        <div
          className={`flex-shrink-0 w-10 h-10 rounded-lg ${config.bg} flex items-center justify-center`}
        >
          <StatusIcon className={`w-5 h-5 ${config.color}`} />
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
              {request.type}
            </span>
            {request.changeOrders.length > 0 &&
              request.changeOrders[0].status !== "approved" && (
                <Badge className="bg-primary/20 text-primary border-primary/30 text-[10px] px-1.5 py-0">
                  Action Required
                </Badge>
              )}
          </div>
          <p className="text-sm text-foreground truncate">
            {request.changes[0]}
          </p>
          <p className="text-xs text-muted-foreground mt-1">
            {new Date(request.createdAt).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
            })}
          </p>
        </div>

        {request.changeOrders.length > 0 && (
          <div className="text-right flex-shrink-0">
            <span className="text-sm font-semibold text-primary">
              {request.changeOrders[0].paymentTerms.currency}{" "}
              {request.changeOrders[0].paymentTerms.totalAmount.toLocaleString()}
            </span>
          </div>
        )}

        <ChevronRight className="w-4 h-4 text-muted-foreground group-hover:text-foreground transition-colors flex-shrink-0" />
      </div>
    </button>
  );
}

